import { CandidateVerification, CandidateVerificationHistory, Pagination } from '@interfaces';

export const searchCandidateVerificationsDefaultPagination = {
  all: 0,
  limit: 25,
  offset: 0,
  orderBy: 'createdAt',
  orderDir: 'desc',
  count: 0,
};

export type CVMState = Readonly<{
  loadingCandidateVerifications: boolean;
  candidateVerifications: Partial<CandidateVerification>[];
  candidateVerificationsPagination: Pagination;

  loadingCandidateVerificationDetails: boolean;
  updatingCandidateVerificationStatus: boolean;
  loadingSavingCandidateVerificationResult: boolean;
  requestingCandidateVerificationSupplementaryInfo: boolean;
  candidateVerificationDetails: Partial<CandidateVerification> | null;
  downloadingCandidateVerificationFileId: string | null;

  deletingCandidateVerification: boolean;

  loadingCandidateVerificationHistory: boolean;
  candidateVerificationHistory: CandidateVerificationHistory[] | null;

  errorMessage: any;
}>;

export const initialState: CVMState = {
  loadingCandidateVerifications: false,
  candidateVerifications: [],
  candidateVerificationsPagination: { ...searchCandidateVerificationsDefaultPagination } as Pagination,

  loadingCandidateVerificationDetails: false,
  updatingCandidateVerificationStatus: false,
  loadingSavingCandidateVerificationResult: false,
  requestingCandidateVerificationSupplementaryInfo: false,
  candidateVerificationDetails: null,
  downloadingCandidateVerificationFileId: null,

  deletingCandidateVerification: false,

  loadingCandidateVerificationHistory: false,
  candidateVerificationHistory: null,

  errorMessage: null,
};
